const PATENT_KEYWORDS = [
  'patent_number', 'patent_title', 'patent_status', 'patent_family',
  'patent_no', 'patent_id', 'patent',
  'filing_date', 'priority_date', 'grant_date', 'expected_grant',
  'applicant', 'assignee', 'patent_holder',
  'claims', 'jurisdiction', 'territory',
  'publication_number', 'publication',
  'wo2', 'us2', 'ep2', 'pct',
];

export function detectPatentColumns(headers: string[]): {
  isPatentData: boolean;
  matchedColumns: string[];
} {
  const matched: string[] = [];
  for (const header of headers) {
    const lower = header.toLowerCase().replace(/[\s\-]/g, '_');
    for (const keyword of PATENT_KEYWORDS) {
      if (lower.includes(keyword)) {
        matched.push(header);
        break;
      }
    }
  }
  return {
    isPatentData: matched.length >= 2,
    matchedColumns: Array.from(new Set(matched)),
  };
}

const SCREENING_KEYWORDS = [
  'ic50', 'ec50', 'ki', 'kd', 'gi50', 'cc50', 'mic',
  'pic50', 'pec50', 'pki',
  'assay', 'inhibition', 'activity', 'response',
  'dose', 'potency', 'emax', 'hill_slope', 'hill',
  'dose_response', 'percent_inhibition', '%_inhibition',
  '%_activity', '%_response',
  'kon', 'koff', 'residence_time',
  'activity_value', 'activity_type',
];

export function detectScreeningColumns(headers: string[]): {
  isScreeningData: boolean;
  matchedColumns: string[];
} {
  const matched: string[] = [];
  for (const header of headers) {
    const lower = header.toLowerCase().replace(/[\s\-]/g, '_');
    for (const keyword of SCREENING_KEYWORDS) {
      if (lower.includes(keyword)) {
        matched.push(header);
        break;
      }
    }
  }
  return {
    isScreeningData: matched.length >= 1,
    matchedColumns: Array.from(new Set(matched)),
  };
}
